import React, { Fragment, useContext, useEffect } from "react";

import Box from '@mui/material/Box';
import AuthContext from "../../context/auth/authContext";
import SpotReviewComposer from "../spots/SpotReviewComposer/SpotReviewComposer";

const CreateSpotReview = () => {
  const authContext = useContext(AuthContext);
  const { loadUser } = authContext;

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <br />
      <br />
      <Box sx={{ width: '100%' }}>
        <SpotReviewComposer />
      </Box>
    </Fragment>
  );
};

export default CreateSpotReview;
